(function () {
  function getLabels() {
    return window.heliumCustomerFieldsI18n || null;
  }

  const fieldExclude = { submit_labels: true, register_submitting: true, account_already_exists: true };

  const accountExistsPattern = /すでにアカウントが存在|An account already exists|该账户已存在|該帳戶已存在/i;

  // Helium の表記ゆれ（「を」あり/なし、…/...）を吸収
  const partialRules = [
    { test: /アカウントを?作成中|Creating account/i, key: 'register_submitting' },
    { test: /ユーザー名を変更中|Changing username/i, key: 'change_username_submitting' },
    { test: /メールアドレスを変更中|Changing email/i, key: 'change_email_submitting' },
    { test: /変更中|Updating/i, key: 'change_submitting' },
  ];

  function normalizeLabel(text) {
    return String(text || '')
      .replace(/\u2026/g, '...')
      .replace(/\u00a0/g, ' ')
      .replace(/[．。]{3,}/g, '...')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function translatedByKey(key) {
    const labels = getLabels();
    if (!labels || !key) return null;

    if (key === 'register_submitting' && labels.register_submitting) {
      return labels.register_submitting;
    }

    const submitLabels = labels.submit_labels || {};
    const submitSources = Object.keys(submitLabels);
    for (var i = 0; i < submitSources.length; i++) {
      var source = submitSources[i];
      if (
        (key === 'register_submitting' && /アカウントを?作成中|Creating account/i.test(source)) ||
        (key === 'change_username_submitting' && /ユーザー名を変更中|Changing username/i.test(source)) ||
        (key === 'change_email_submitting' && /メールアドレスを変更中|Changing email/i.test(source)) ||
        (key === 'change_submitting' && (/^変更中/.test(source) || /^Updating/i.test(source)))
      ) {
        return submitLabels[source];
      }
    }
    return null;
  }

  function lookupSubmitLabel(text) {
    const labels = getLabels();
    if (!labels) return null;

    const submitLabels = labels.submit_labels || {};
    const submitSources = Object.keys(submitLabels);
    const trimmed = String(text || '').trim();
    if (!trimmed) return null;
    if (submitLabels[trimmed]) return submitLabels[trimmed];

    const normalized = normalizeLabel(trimmed);
    if (submitLabels[normalized]) return submitLabels[normalized];

    for (var i = 0; i < submitSources.length; i++) {
      if (normalizeLabel(submitSources[i]) === normalized) {
        return submitLabels[submitSources[i]];
      }
    }

    for (var j = 0; j < partialRules.length; j++) {
      if (partialRules[j].test.test(normalized)) {
        return translatedByKey(partialRules[j].key);
      }
    }

    return null;
  }

  function localizeField(input) {
    const labels = getLabels();
    if (!labels) return;

    const key = input.getAttribute('data-cf-column-key') || input.getAttribute('name');
    if (!key || !labels[key] || fieldExclude[key]) return;

    const text = labels[key];
    const field = input.closest('.cf-field');
    const label = field && field.querySelector('label');

    if (label) label.textContent = text;
    input.setAttribute('placeholder', text);
  }

  function localizeAllFields(root) {
    const labels = getLabels();
    if (!labels) return;

    root = root || document;
    Object.keys(labels).forEach(function (key) {
      if (fieldExclude[key]) return;
      root.querySelectorAll('.cf-field input[name="' + key + '"]').forEach(localizeField);
    });
  }

  function replaceLabeledText(node) {
    if (!node || node.nodeType !== 3) return false;
    const raw = node.textContent;
    const trimmed = raw.trim();
    const replacement = lookupSubmitLabel(trimmed);
    if (!trimmed || !replacement) return false;
    if (trimmed === replacement) return false;
    node.textContent = raw.replace(trimmed, replacement);
    return true;
  }

  function localizeSubmitButton(button) {
    const labels = getLabels();
    if (!button || !labels || !labels.submit_labels) return;

    Array.prototype.forEach.call(button.childNodes, replaceLabeledText);

    button.querySelectorAll('*').forEach(function (el) {
      Array.prototype.forEach.call(el.childNodes, replaceLabeledText);
    });

    const whole = normalizeLabel(button.textContent);
    const wholeReplacement = lookupSubmitLabel(whole);
    if (wholeReplacement && whole !== normalizeLabel(wholeReplacement)) {
      if (!button.querySelector('svg, img, i, .cf-spinner, .spinner')) {
        const span = button.querySelector('span');
        if (span && !span.querySelector('svg, img, i')) {
          span.textContent = wholeReplacement;
        } else {
          button.textContent = wholeReplacement;
        }
      } else {
        Array.prototype.forEach.call(button.childNodes, function (node) {
          if (node.nodeType === 3 && lookupSubmitLabel(node.textContent.trim())) {
            replaceLabeledText(node);
          }
        });
      }
    }

    if (button.tagName === 'INPUT' && (button.type === 'submit' || button.type === 'button')) {
      const valueReplacement = lookupSubmitLabel(button.value);
      if (valueReplacement && button.value !== valueReplacement) {
        button.value = valueReplacement;
      }
    }
  }

  function submitButtonSelector() {
    return [
      '.cf-submit-form',
      'form[data-cf-form] button[type="submit"]',
      'form[data-cf-form] button',
      'form[data-cf-form] input[type="submit"]',
      '#create_customer button[type="submit"]',
      '#create_customer button',
      '.cf-form button[type="submit"]',
      '.cf-form button',
      '.cf-form-actions button',
      '.cf-react-target button[type="submit"]',
    ].join(', ');
  }

  function localizeAllSubmits(root) {
    root = root || document;
    if (root.matches && root.matches(submitButtonSelector())) {
      localizeSubmitButton(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(submitButtonSelector()).forEach(localizeSubmitButton);
    }
  }

  function localizeAll(root) {
    localizeAllFields(root);
    localizeAllSubmits(root);
    localizeAccountExists(root);
  }

  function localizeAccountExists(root) {
    const labels = getLabels();
    const msg = labels && labels.account_already_exists;
    if (!msg) return;

    root = root || document;
    const inners = [];
    if (root.matches && root.matches('.cf-form-inner')) inners.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('.cf-form-inner').forEach(function (el) {
        inners.push(el);
      });
    }

    inners.forEach(function (inner) {
      if (!inner.querySelector('.cf-step-invalid')) return;

      // Helium 本体のメッセージを翻訳文言で差し替え（CSS :after と二重になっても同じ文言）
      inner.querySelectorAll('.cf-error-message, .cf-step-invalid').forEach(function (el) {
        if (!el.childElementCount && accountExistsPattern.test(el.textContent || '')) {
          el.textContent = msg;
        } else {
          Array.prototype.forEach.call(el.childNodes, function (node) {
            if (node.nodeType === 3 && accountExistsPattern.test(node.textContent || '')) {
              node.textContent = msg;
            }
          });
        }
      });
    });
  }

  function pollLocalize(times, intervalMs) {
    var count = 0;
    var timer = setInterval(function () {
      localizeAllSubmits();
      localizeAccountExists();
      count += 1;
      if (count >= times) clearInterval(timer);
    }, intervalMs);
  }

  function init() {
    localizeAll();

    const observer = new MutationObserver(function (mutations) {
      var shouldScan = false;
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          const parent = mutation.target && mutation.target.parentElement;
          const button = parent && parent.closest(submitButtonSelector());
          if (button) localizeSubmitButton(button);
          else shouldScan = true;
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          shouldScan = true;
          localizeAll(node);
        });

        if (mutation.type === 'attributes' && mutation.target) {
          const button = mutation.target.closest ? mutation.target.closest(submitButtonSelector()) : null;
          if (button) localizeSubmitButton(button);
          else shouldScan = true;
        }
      });
      if (shouldScan) {
        localizeAllSubmits();
        localizeAccountExists();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'disabled', 'value', 'aria-busy', 'aria-disabled'],
    });

    // Helium が submit 後に遅延で文言を差し替えるケース向け
    function onSubmitIntent(event) {
      const button =
        (event.target && event.target.closest && event.target.closest(submitButtonSelector())) ||
        (event.target &&
          event.target.closest &&
          event.target.closest('.cf-form-inner, .cf-react-target, #create_customer') &&
          document.querySelector(submitButtonSelector()));
      if (!button && !(event.target && event.target.closest && event.target.closest('.cf-form-inner, .cf-react-target, form'))) {
        return;
      }
      pollLocalize(40, 50);
    }

    document.addEventListener('click', onSubmitIntent, true);
    document.addEventListener('submit', onSubmitIntent, true);
  }

  function boot() {
    var started = false;
    function start() {
      if (started) return;
      if (!getLabels()) return;
      started = true;
      init();
    }

    start();
    if (!started) {
      var wait = 0;
      var waitTimer = setInterval(function () {
        wait += 1;
        start();
        if (started || wait >= 40) clearInterval(waitTimer);
      }, 100);
    }

    if (window.CF && typeof window.CF.ready === 'function') {
      window.CF.ready(function () {
        localizeAll();
      });
    } else {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (window.CF && typeof window.CF.ready === 'function') {
          clearInterval(timer);
          window.CF.ready(function () {
            localizeAll();
          });
        } else if (tries >= 20) {
          clearInterval(timer);
        } else {
          localizeAll();
        }
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
